import get from "lodash-es/get";
import {
  VIEW_LICENSE_TEMPLATE_PERMISSION,
  VIEW_LICENSE_LIMIT_PERMISSION,
  VIEW_LICENSE_FEATURES_PERMISSION,
  VIEW_SETTINGS_GROUPS,
  VIEW_SETTINGS_USERS,
  VIEW_SETTINGS_TLS,
  VIEW_SETTINGS_SYSTEM_EVENTS,
  VIEW_SETTINGS_SERVICES,
  VIEW_SETTINGS_SERVERS,
  SHOW_XMLs_PERMISSION,
  VIEW_ACCOUNT_FILES_PERMISSION,
  VIEW_ACCOUNT_LICENSE_PERMISSION,
  VIEW_ACCOUNT_PUSH_CENTERS_PERMISSION,
  VIEW_ACCOUNT_PACKAGES_PERMISSION,
  VIEW_ACCOUNT_REGISTERED_PERMISSION,
  VIEW_ACCOUNT_SYSTEM_EVENTS_PERMISSION,
  VIEW_ACCOUNT_DASHBOARD_PERMISSION,
} from "constants/permissions";

export const authMapper = (data) => extractAuthData(data.token_auth);

export const oktaAuthMapper = (data) => extractAuthData(data.okta_auth);

const extractAuthData = (data) => ({
  token: data.token,
  refresh_token: data.refresh_token,
  payload: {
    ...data.payload,
    permissions: extractPermissions(get(data, "payload.permissions")),
  },
});

export const iamTypesMapper = (data) => ({
  remoteIamEnabled: get(data, "authentication.remote_iam_enabled", false),
  iamTypes: get(data, "authentication.iam_types", []).map((item) =>
    JSON.parse(item),
  ),
});

const extractPermissions = (data) => {
  if (!data) return {};
  const permissions = data.reduce(
    (acc, permission) =>
      Object.assign(acc, { [permission.codename]: permission.checked }),
    {},
  );

  permissions.ui_view_account = createSomePermission(
    permissions,
    uiViewAccount,
  );

  permissions.ui_view_licenses = createSomePermission(
    permissions,
    uiViewLicensesPermissions,
  );

  permissions.ui_view_version = createSomePermission(
    permissions,
    uiViewVersion,
  );

  permissions.ui_view_essentials = createSomePermission(
    permissions,
    uiViewVersions,
  );

  permissions.ui_view_push_centers = createSomePermission(
    permissions,
    uiViewPushCenters,
  );

  permissions.ui_view_iu_version = createSomePermission(
    permissions,
    uiViewIUVersion,
  );

  permissions.ui_view_settings = createSomePermission(
    permissions,
    uiViewSettingsPermissions,
  );

  return permissions;
};

const createSomePermission = (data, permissions) =>
  permissions.some((name) => data[name]);

const uiViewAccount = [
  VIEW_ACCOUNT_REGISTERED_PERMISSION,
  VIEW_ACCOUNT_LICENSE_PERMISSION,
  VIEW_ACCOUNT_FILES_PERMISSION,
  VIEW_ACCOUNT_PUSH_CENTERS_PERMISSION,
  VIEW_ACCOUNT_PACKAGES_PERMISSION,
  VIEW_ACCOUNT_SYSTEM_EVENTS_PERMISSION,
  VIEW_ACCOUNT_DASHBOARD_PERMISSION,
];

const uiViewLicensesPermissions = [
  VIEW_LICENSE_TEMPLATE_PERMISSION,
  VIEW_LICENSE_LIMIT_PERMISSION,
  VIEW_LICENSE_FEATURES_PERMISSION,
];

const uiViewVersion = ["view_essentials_files", "view_essentials_locales"];

const uiViewVersions = ["view_essentials", SHOW_XMLs_PERMISSION];

const uiViewPushCenters = ["view_push_centers_apns", "view_push_centers_fcm"];

const uiViewIUVersion = [
  "view_incremental_upgrade_packages",
  "view_incremental_upgrade_repos",
];

const uiViewSettingsPermissions = [
  VIEW_SETTINGS_USERS,
  VIEW_SETTINGS_GROUPS,
  VIEW_SETTINGS_TLS,
  VIEW_SETTINGS_SYSTEM_EVENTS,
  VIEW_SETTINGS_SERVICES,
  VIEW_SETTINGS_SERVERS,
];

export const refreshAuthMapper = (data) => ({
  token: data.refresh_token.token,
  refresh_token: data.refresh_token.refresh_token,
  payload: {
    ...data.refresh_token.payload,
    permissions: extractPermissions(data.refresh_token.payload.permissions),
  },
});
